export const TABLE_REQUIRED_FIELD_NAME = "table_required";

export const TABLE_NO_ROWS_MESSAGE =
  "This table is required, please add at least one row and fill it in!";

export const TABLE_INCOMPLETE_ROW_MESSAGE =
  "Please fill in every column of this table!";

// Checkboxes and dropdowns always carry a value once rendered, so blocking on
// them would make "no" and first-option answers impossible to submit.
const SELF_ANSWERING_COLUMN_TYPES = ["checkbox", "select"];

function isCellEmpty(cell) {
  const values = Object.values(cell || {});
  if (values.length === 0) return true;
  return values.every(
    (value) =>
      value === undefined ||
      value === null ||
      value === false ||
      String(value).trim() === ""
  );
}

/**
 * Validates a required table against its live form values. Table values are
 * kept as rows[].columns[] = { [columnName]: value } and a freshly created
 * table already ships with one blank row, so every row has to be complete
 * before the table counts as answered.
 *
 * Returns the message to show, or "" when the table is valid.
 */
export function getRequiredTableError(tableValue, columns) {
  const rows = tableValue?.rows;
  if (!Array.isArray(rows) || rows.length === 0) return TABLE_NO_ROWS_MESSAGE;

  const tableColumns = Array.isArray(columns) ? columns : [];

  const hasIncompleteRow = rows.some((row) => {
    const cells = Array.isArray(row?.columns) ? row.columns : [];
    if (tableColumns.length === 0) return isCellEmpty(cells[0]);

    return tableColumns.some(
      (column, columnIndex) =>
        !SELF_ANSWERING_COLUMN_TYPES.includes(column?.type) &&
        isCellEmpty(cells[columnIndex])
    );
  });

  return hasIncompleteRow ? TABLE_INCOMPLETE_ROW_MESSAGE : "";
}
